import { mapGetters } from 'vuex';
import { successMessage, errorMessage } from '@/utils/message.js';
import accountInfoService from '../../account-info.service.js';
import regExp from '@/utils/regExp.js';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import VoiceMessage from '@/components/voice-message/index.vue';
export default {
  components: {
    ProcessNavigation,
    VoiceMessage
  },
  data() {
    return {
      processList: ['变更后法人信息', '业务审批员审批', '变更后法人验证'],
      assignorIdTypeList: [],
      smsCodeShowCount: 60,
      smsCodeShowText: '获取验证码',
      step: 1,
      form: {
        legalMobile: '',
        assignorCode: '',
        verifyCode: ''
      },
      rules: {
        legalMobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: regExp.phone, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ],
        assignorCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'captchaImageSrc',
      'ticket',
      'userType',
      'isHeilongjiang'
    ])
  },
  created() {
    if (this.userInfo.type === 2) {
      this.processList =  ['变更后法人信息', '变更后法人验证'];
    } else {
      this.processList =  ['变更后法人信息', '业务审批员审批'];
    }
    this.updateCaptchaImage();
    this.getChangeMobile();
  },
  methods: {
    // 获取变更后的手机号码
    getChangeMobile () {
      accountInfoService.getChangeMobile().then(({ code, data }) => {
        if (code === '0') {
          this.form.legalMobile = data;
        }
      });
    },
    // 更新图片验证码
    updateCaptchaImage() {
      this.$store.dispatch('getCodeImage').then(() => {
      }, error => {
        if (error && error.reason) {
          errorMessage(error.reason);
        } else {
          errorMessage('更新验证码失败，请重试');
        }
      });
    },
    // 手机验证码倒计时
    countDownOfSmsCode() {
      let _this = this;
      if (this.smsCodeShowCount >= 1) {
        _this.timer = setInterval(function() {
          _this.smsCodeShowCount--;
          _this.smsCodeShowText = _this.smsCodeShowCount + 'S';
          if (_this.smsCodeShowCount <= 0) {
            _this.smsCodeShowText = '重新获取';
            _this.smsCodeShowCount = 60;
            clearInterval(_this.timer);
          }
        }, 1000);
      }
    },
    // 获取手机验证码
    getSmsCode() {
      const mobile = this.form.legalMobile;
      if (!this.form.verifyCode) {
        errorMessage('请先输入图片验证码');
        return;
      }
      if (this.form.verifyCode && this.form.verifyCode.length !== 4) {
        errorMessage('请输入正确的图片验证码');
        return;
      }
      const form = {mobile: mobile, ticket: this.ticket, verifyCode: this.form.verifyCode};
      if (this.smsCodeShowCount === 60) {
        this.smsCodeShowText = '发送中...';
        this.$store.dispatch('getSmsCode', form).then(res => {
          if (res.code === '0') {
            this.countDownOfSmsCode();
            successMessage('验证码发送成功');
          }
        }, error => {
          this.updateCaptchaImage();
          this.smsCodeShowText = '重新获取';
          this.smsCodeShowCount = 60;
          if (error && error.reason) {
            errorMessage(error.reason);
          } else {
            errorMessage('获取验证码失败，请重试');
          }
        });
      }
    },
    validateForm() {
      let validStatus = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          validStatus = valid;
        }
      });
      return validStatus;
    },
    submit() {
      if (!this.validateForm()) { return; };
      let params = {
        companyForm: this.form
      };
      accountInfoService.submitChangeLegal(params).then(res => {
        if (res && res.code === '0') {
          // 信息修改成功后 清除信息并跳转到登陆页面
          successMessage('法人变更成功');
          this.$router.push('/person-center/account-info/member-info');
        } else {
          errorMessage(res.reason);
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
};
